import { Injectable } from '@angular/core';
@Injectable()
export class PendingChangesService {
    pendingChanges: boolean;
}
